import React from 'react';
import './FilesBreadcrumb.css';
import { Breadcrumb } from 'react-bootstrap';

const FilesBreadcrumb = ({ path, currentItem, onNavigate }) => {

    return (
        <Breadcrumb className='files-breadcrumb'>
        {path.map((folder, index) => {
            return (
                <Breadcrumb.Item key={index} active={folder.id == currentItem} onClick={() => onNavigate(index)}>
                    {folder.name}
                </Breadcrumb.Item>
            )
        })}
        </Breadcrumb>
    )
};

export default FilesBreadcrumb;